import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Body,
  ContainerInputs,
  EditarSubstratoContainer,
} from "./styles";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import voltar from "../../../../assets/voltar.svg";
import { NovoSubstratoSchema } from "../../../../schemas/novoCadastro";
import { toast } from "react-toastify";
import api from "../../../../services/api";
import { ReactSVG } from "react-svg";

const EditarSubstrato = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    register,
    getValues,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(NovoSubstratoSchema),
  });

  const onSubmitFunction = () => {
    const formValues = getValues();

    api
      .patch(`/substrato/${id}`, formValues)
      .then((response) => {
        navigate("/substratos");
        toast.success("Substrato atualizado com sucesso!");
      })
      .catch((error) => {
        toast.error("Algo deu errado ao atualizar o substrato.");
      });
  };

  function buscarSubstratoId() {
    api
      .get(`/substrato/${id}`)
      .then((response) => {
        reset(response.data.data.substrato);
      })
      .catch((error) => {
        console.error("Erro ao buscar dados da API:", error);
        toast.error("Erro ao buscar dados");
      });
  }

  useEffect(() => {
    buscarSubstratoId();
  }, [id]);

  return (
    <EditarSubstratoContainer onSubmit={handleSubmit(onSubmitFunction)}>
      <div className="box">
        <div className="flex">
          <ReactSVG
            onClick={() => navigate("/substratos")}
            className="voltar"
            src={voltar}
          />
          <div>
            <h1>Substrato</h1>
            <span className="underline">Editar Substrato</span>
          </div>
        </div>
        <Body>
          <div className="checkbox">
            <input
              type="checkbox"
              id="checkbox1"
              name="status"
              {...register("status")}
            />
            <label htmlFor="checkbox1">Ativo</label>
          </div>
          <ContainerInputs>
            <div>
              <label>Nome*</label>
              <input
                type="text"
                name="nome"
                {...register("nome")}
                placeholder="Nome do produto/serviço"
              />
              {errors.nome && (
                <span className="input-error-cadastro">
                  {errors.nome.message}
                </span>
              )}
            </div>
            <div>
              <label>Gramatura/Espessura*</label>
              <input
                type="text"
                name="gramatura_espessura"
                {...register("gramatura_espessura")}
                placeholder="Gramatura/Espessura"
              />
              {errors.gramatura_espessura && (
                <span className="input-error-cadastro">
                  {errors.gramatura_espessura.message}
                </span>
              )}
            </div>
          </ContainerInputs>
          <ContainerInputs>
            <div className=" margin-bottom-40px">
              <label htmlFor="checkbox-reciclado">Reciclado</label>
              <input type="checkbox" className="checkbox-input" id="checkbox-reciclado" name="reciclado" {...register("reciclado")} />
            </div>
            <div className="margin-bottom-40px">
              <label htmlFor="checkbox-certificado">Certificado</label>
              <input type="checkbox" className="checkbox-input" id="checkbox-certificado" name="certificado" {...register("certificado")} />
            </div>
            <div className="margin-bottom-40px">
              <label htmlFor="checkbox-reciclavel">Reciclável</label>
              <input type="checkbox" className="checkbox-input" id="checkbox-reciclavel" name="reciclavel" {...register("reciclavel")} />
            </div>
          </ContainerInputs>
        </Body>
        <div className="buttons">
          <Link to="/substratos">{"< Voltar"}</Link>
          <button type="submit">Salvar</button>
        </div>
      </div>
    </EditarSubstratoContainer>
  );
};

export default EditarSubstrato;
